var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHolidayRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43.81 43.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3,
    y1: 34.6,
    x2: 33.67,
    y2: 34.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b4d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e25e68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2.99,
    y1: 12.72,
    x2: 46.8,
    y2: 12.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 35.11,
    y1: 37.37,
    x2: 46.79,
    y2: 37.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 37.32,
    y1: 24.74,
    x2: 44.6,
    y2: 24.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 38.9,
    y1: 34.59,
    x2: 43,
    y2: 34.59,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.73,31a3.7,3.7,0,0,1,2.94,3.81V46.05c0,.73-.24,1-1,1S31,47,30.11,47a.73.73,0,0,1-.84-.84V44.12H7.41c0,.11,0,.23,0,.35,0,.6,0,1.19,0,1.79a.71.71,0,0,1-.75.75c-1,0-1.92,0-2.87,0a.71.71,0,0,1-.77-.8c0-1.42,0-2.84,0-4.27V34.69a3.61,3.61,0,0,1,2.66-3.6c.24-.08.27-.19.27-.4q0-3.09,0-6.2a2.18,2.18,0,0,1,2.3-2.31H28.43a2.17,2.17,0,0,1,2.3,2.3V31ZM4.47,38.23H32.16a.55.55,0,0,0,0-.16c0-1.16,0-2.33,0-3.5a2.16,2.16,0,0,0-.64-1.51,2.51,2.51,0,0,0-1.89-.65H6.58a2.17,2.17,0,0,0-2.11,2.21v3.59Zm27.71,1.51H4.5v5.79H5.92V43.44a.73.73,0,0,1,.83-.82H29.9a.73.73,0,0,1,.83.84v2.06h1.45ZM19.05,30.92v-.41c0-.83,0-1.66,0-2.49a2.12,2.12,0,0,1,2-2.16c1.5-.05,3-.07,4.51,0a2.18,2.18,0,0,1,2.26,2.43v2.27c0,.13,0,.25,0,.37h1.42V24.66c0-.77-.23-1-1-1H8.44c-.85,0-1,.2-1,1.05v6.2H8.82v-.68c0-.85,0-1.7.06-2.55a2,2,0,0,1,1.92-1.82c1.53-.05,3.06-.08,4.59,0a2.15,2.15,0,0,1,2.21,2.39v2.31c0,.13,0,.25,0,.38Zm7.29,0c0-1,0-2,0-2.94,0-.43-.31-.66-.79-.66H21.38a.75.75,0,0,0-.86.86c0,.48,0,.95,0,1.43v1.31Zm-16,0h5.8c0-1,0-2,0-2.93a.66.66,0,0,0-.72-.65c-1.44,0-2.89,0-4.34,0a.68.68,0,0,0-.73.72c0,.37,0,.74,0,1.11Z",
    transform: "translate(-2.99 -3.23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.79,17.45v3.71c0,.7-.25,1.05-.74,1s-.73-.35-.73-1q0-3.45,0-6.9a.45.45,0,0,0-.31-.49L25.11,4.86a.62.62,0,0,0-.48,0L7.31,12.64c-.84.38-1.68.77-2.52,1.13a.44.44,0,0,0-.32.49c0,2.29,0,4.58,0,6.86a3.46,3.46,0,0,1,0,.46.71.71,0,0,1-.72.62A.74.74,0,0,1,3,21.57a2.61,2.61,0,0,1,0-.28q0-3.84,0-7.68a.91.91,0,0,1,.62-.93L24.43,3.34a1,1,0,0,1,.94,0L46.23,12.7a.84.84,0,0,1,.57.86C46.78,14.86,46.79,16.15,46.79,17.45Z",
    transform: "translate(-2.99 -3.23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.32,38.27H36.59v4.67c0,.51-.26.83-.68.85a.71.71,0,0,1-.8-.7c0-.25,0-.51,0-.77V31.88c0-.69.25-.94,1-.94q4.9,0,9.81,0c.68,0,.92.24.92.93V42.94c0,.5-.2.79-.6.85a.73.73,0,0,1-.87-.8V38.27Zm0-1.51V32.44H36.62v4.32Z",
    transform: "translate(-2.99 -3.23)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.7,25.89V28H43a.72.72,0,0,1,.77.72.74.74,0,0,1-.77.74h-4a.73.73,0,0,1-.76-.74.7.7,0,0,1,.76-.72h1.24V25.85H38.45c-1.1,0-1.33-.33-1-1.38l1.26-3.77c.19-.57.38-.71,1-.71h2.56a.8.8,0,0,1,.92.67l1.35,4c.24.72-.06,1.14-.82,1.15H41.78Zm1.14-1.53c-.32-1-.61-1.87-.93-2.76,0-.07-.17-.13-.27-.14q-.53,0-1,0c-.68,0-.51-.1-.73.53-.27.78-.52,1.56-.79,2.37Z",
    transform: "translate(-2.99 -3.23)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41,35.33h-1.3a.73.73,0,0,1-.76-.74.74.74,0,0,1,.77-.73h2.55a.73.73,0,0,1,.78.76.7.7,0,0,1-.78.71Z",
    transform: "translate(-2.99 -3.23)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHolidayRoom);
export default __webpack_public_path__ + "static/media/icon-holiday-room.bb0ffca07bd6d60af03a88276cea8b00.svg";
export { ForwardRef as ReactComponent };